import { whoWeAreIntro, whoWeAreProfiles } from "@/content/siteContent";

export default function AboutPage() {
  return (
    <div data-testid="who-we-are-page">
      <section className="bg-slate-950 py-24 text-white md:py-28" data-testid="who-we-are-hero-section">
        <div className="mx-auto max-w-5xl px-6 md:px-12">
          <div className="space-y-6">
            <h1 className="text-4xl font-bold tracking-tight text-white sm:text-5xl lg:text-6xl" data-testid="who-we-are-heading">
              Who We Are
            </h1>
            {whoWeAreIntro.map((paragraph, index) => (
              <p
                key={paragraph}
                className="max-w-4xl text-base text-slate-300 md:text-lg"
                data-testid={`who-we-are-intro-paragraph-${index + 1}`}
              >
                {paragraph}
              </p>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-white py-24 md:py-28" data-testid="who-we-are-profiles-section">
        <div className="mx-auto max-w-7xl px-6 md:px-12">
          <div className="grid gap-8">
            {whoWeAreProfiles.map((profile, index) => (
              <article
                key={profile.slug}
                className="border border-slate-200 bg-slate-50 p-8 md:p-10"
                data-testid={`who-we-are-profile-${profile.slug}`}
              >
                <div className="grid gap-8 lg:grid-cols-[0.85fr_1.15fr] lg:items-start">
                  <div className={index % 2 === 1 ? "lg:order-2" : ""}>
                    <div className="overflow-hidden border border-slate-200 bg-white shadow-sm" data-testid={`who-we-are-profile-image-frame-${profile.slug}`}>
                      <img
                        alt={profile.title}
                        className="aspect-[4/5] w-full object-cover object-center"
                        data-testid={`who-we-are-profile-image-${profile.slug}`}
                        src={profile.image}
                      />
                    </div>
                  </div>
                  <div className={index % 2 === 1 ? "lg:order-1" : ""}>
                    <h2 className="text-3xl font-bold tracking-tight text-slate-950 md:text-4xl" data-testid={`who-we-are-profile-title-${profile.slug}`}>
                      {profile.title}
                    </h2>
                    <div className="mt-6 grid gap-4">
                      {profile.paragraphs.map((paragraph, paragraphIndex) => (
                        <p
                          key={paragraph}
                          className="text-base text-slate-700 md:text-lg"
                          data-testid={`who-we-are-profile-paragraph-${profile.slug}-${paragraphIndex + 1}`}
                        >
                          {paragraph}
                        </p>
                      ))}
                    </div>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
